import { Moment } from 'moment';

export type Risk =
  | 'at-risk'
  | 'below-normal'
  | 'normal-range'
  | 'top-performers';

export type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export type MediaType = 'snapshot' | 'video' | 'none';

export interface Clickable {
  onClick?: (...args: any[]) => void;
}

export type DeviceState = 'lost' | 'moving' | 'none' | 'parked' | 'stopped';
export const deviceStates: DeviceState[] = [
  'lost',
  'moving',
  'none',
  'parked',
  'stopped',
];

export interface Entity {
  'driver-snapshot'?: string;
  id?: string;
  name?: string;
}
export type EntityType = 'driver' | 'vehicle';
export const entityTypes: EntityType[] = ['driver', 'vehicle'];
